module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABzSURBVHgBldGLDYAgDATQ0gkcxRUcgUk7giu4gSswQWPPhAS1BbmEpAkPyofIIiILBgVhTDLziWH16qKmBt49yDnnoqqb1SWCqRaYAADEAiy0DY4H6sH07u/BD/Ig04/MtxsefPgEPXCj+ncRQNrbuQC5ADgUZQ6HNxj9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/greater_than_icn.png
// module id = hvGX
// module chunks = 1